import React from 'react';
import ReactDOM from 'react-dom';
import SalonTherapiesPage from './SalonTherapiesPage';

var salonTherapiesJson = JSON.parse(document.getElementById("SalonTherapiesJson").textContent); // eslint-disable-next-line
var instagram = JSON.parse(document.getElementById("instagram").textContent); // eslint-disable-next-line
var breadcrumbs = JSON.parse(document.getElementById("breadcrumbJson").textContent); // eslint-disable-next-line
var language = document.getElementById('divlang').getAttribute('data-id'); // eslint-disable-next-line
var salonCountries = JSON.parse(document.getElementById("salonCountries").textContent); // eslint-disable-next-line
ReactDOM.render(<SalonTherapiesPage
        breadcrumbs={breadcrumbs}
        salonTherapies={salonTherapiesJson}
        instagram={instagram}
        lang={language}
        salonCountries={salonCountries}
    />,
    document.getElementById('SalonTherapiesIndex'));
